<template>
  <CommonExpansionPanel :currentPanel="0">
    <template v-slot:title-panel>
      Servicio de envió de registros para onboarding Marketing Cloud
    </template>
    <v-expansion-panel-content>
      <ReporteOnboardFilters
        @searchUpdated="getEmisionesOnboarding"
        :currentFilters="filtros"
        :currentAlianza="alianza"
        @alianzaUpdated="alianza = $event"
        :loading="loading"
      >
      </ReporteOnboardFilters>
      <hr />
      <ReporteOnboardTable
        :loading="loading"
        :emisiones="emisiones"
        :totalItems="totalItems"
        :page="page"
        :itemsPerPage="itemsPerPage"
        @pageChanged="onPageChanged"
        @itemsPerPageChanged="onItemsPerPageChanged"
      />
    </v-expansion-panel-content>
    <v-row class="py-4 px-6 align-center justify-space-between">
      <v-col cols="12" md="6">
        <h3 class="mb-0" style="color: #42352E;">
          Registros para envío: <strong>{{ totalItems }}</strong>
        </h3>
      </v-col>
      <v-col cols="12" md="6" class="text-end">
        <v-btn
          dark
          color="#00a7e4"
          rounded
          class="mr-2"
          min-width="120"
          :loading="loading"
          @click="sendOnboarding"
        >
          Enviar
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="py-4 px-6" v-if="loading && totalBatches > 0">
      <v-alert type="info" class="w-100">
        Enviando bloque {{ batchActual }} de {{ totalBatches }}
      </v-alert>
    </v-row>
  </CommonExpansionPanel>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import {
  getEmisionesOnboard,
  getEmisionesOnboardIds,
  postEmisionesOnboard,
} from "../../../../services/emision/emision.service";
import ReporteOnboardFilters from "./ReporteOnboardFilters.vue";
import ReporteOnboardTable from "./ReporteOnboardTable.vue";

export default {
  components: {
    CommonExpansionPanel,
    ReporteOnboardFilters,
    ReporteOnboardTable,
  },

  data() {
    return {
      switch_data: 1,
      emisiones: [],
      emisionesIds: [],
      filtros: {},
      alianza: {},
      loading: false,
      page: 1,
      totalItems: 0,
      itemsPerPage: 10,
      batchActual: 0,
      totalBatches: 0,
    };
  },
  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
  },
  methods: {
    async getEmisionesOnboarding(filtros = this.filtros) {
      this.loading = true;
      this.filtros = filtros;
      try {
        const offset = (this.page - 1) * this.itemsPerPage;
        let response = null;

        try {
          response = await getEmisionesOnboard(
            filtros,
            this.itemsPerPage,
            offset
          );
        } catch (error) {
          console.warn("Error al obtener emisiones:", error);
        }

        if (response?.data && response?.data.length) {
          this.emisiones = response.data.map((emision) => {
            const result = {
              ...emision,
            };
            return result;
          });

          this.totalItems = response.count;
          this.emisionesIds = await getEmisionesOnboardIds(filtros);
        } else {
          this.emisiones = [];
          this.totalItems = 0;
        }
      } finally {
        this.loading = false;
      }
    },

    onPageChanged(newPage) {
      this.page = newPage;
      this.getEmisionesOnboarding();
    },
    onItemsPerPageChanged(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      this.getEmisionesOnboarding();
    },

    async sendOnboarding() {
      this.loading = true;

      const limiteBloque = this.alianza?.envios_onboarding ?? 10;

      if (this.totalItems === 0 || this.emisionesIds.length === 0) {
        this.$toast.warning("No hay emisiones para enviar");
        this.loading = false;
        return;
      }

      try {
        const payload = this.emisionesIds;
        const bloqueTam = limiteBloque === 0 ? payload.length : limiteBloque;

        this.totalBatches = Math.ceil(payload.length / bloqueTam);
        this.batchActual = 0;

        this.$toast.info("Enviando emisiones por bloques...");

        for (let i = 0; i < payload.length; i += bloqueTam) {
          this.batchActual++;

          const bloque = payload.slice(i, i + bloqueTam);

          try {
            await postEmisionesOnboard(bloque);
          } catch (error) {
            console.error("Error en el bloque:", error);
            this.$toast.error(`Error al enviar el bloque ${this.batchActual}`);
          }
        }

        this.$toast.success("Todas las emisiones fueron enviadas");
        this.emisiones = [];
        this.totalItems = 0;
      } catch (error) {
        console.error("Error general:", error);
        this.$toast.error("Algo falló al enviar las emisiones");
      } finally {
        this.emisiones = [];
        this.loading = false;
        this.batchActual = 0;
        this.totalBatches = 0;
      }
    },
  },
  mounted() {},
};
</script>
